import React from 'react';
import Table from 'react-bootstrap/Table';

const PricingOverwriteTable = ({ selectedSize, numberOfLogos, wholesaleCost, desiredMargin, overwriteCost, totalHCPerItem, quantity }) => {
  //const [data, setData] = useState([]);

  // useEffect(() => {
  //   fetch('/pricingDataFix.json')
  //     .then(response => response.json())
  //     .then(data => setData(data));
  // }, []);

  //const selectedData = data.find(item => item.SIZE === selectedSize);
  //const quantityMargins = [1.48, 1.45, 1.37, 1.35, 1.30];
  const quantities = [50, 100, 250, 500, 1000];
  const marginGap = [0, 0.03, 0.11, 0.13, 0.18];


  // const calculatePrice = (qty) => {
  //   if (selectedData) {
  //     const decorationCost = selectedData[qty] || 0;
  //     //const totalHardCost = (wholesaleCost + decorationCost * numberOfLogos) * qty;
  //     //const hcPerItem = totalHardCost / qty;
  //     const hcPerItem = wholesaleCost + decorationCost * numberOfLogos;
  //     // console.log(qty);
  //     // console.log(wholesaleCost);
  //     // console.log(decorationCost);
  //     // console.log(numberOfLogos);
  //     // console.log(hcPerItem);
  //     //const salePrice = hcPerItem * (desiredMargin || quantityMargins[quantities.indexOf(qty)]);
  //     return {
  //       //totalHardCost: totalHardCost.toFixed(2),
  //       hcPerItem: hcPerItem.toFixed(2),
  //       //salePrice: salePrice.toFixed(2),
  //       //afterDiscount: (salePrice * 0.9).toFixed(2) // Assuming a 10% discount
  //     };
  //   }
  //   return {
  //     //totalHardCost: '',
  //     hcPerItem: '',
  //     //salePrice: 'N/A',
  //     //afterDiscount: 'N/A'
  //   };
  // };

  return (
    <div>
      <h3>Overwrite Pricing</h3>
      <Table striped bordered hover>
        <thead>
          <tr>
            <td>Estimate Customer Pay Per Item (Margin)</td>
            <td>Estimate Merch Total Price (Qty: {quantity})</td>
            <td>Discount to Customer</td>
          </tr>
        </thead>
        <tbody>
          {quantities.map((qty, index) => {
            const overwriteMargin = (overwriteCost / totalHCPerItem);
            const customerPayPerItem = (totalHCPerItem * (overwriteMargin - marginGap[index])).toFixed(2);
            const isLowerThanHardCost2 = parseFloat(customerPayPerItem) < totalHCPerItem;

            return (
              <tr key={qty}>
                <td className={isLowerThanHardCost2 ? 'text-danger' : ''}>$ {customerPayPerItem} ({(overwriteMargin - marginGap[index]).toFixed(2)})</td>
                <td className={isLowerThanHardCost2 ? 'text-danger' : ''}> ${(quantity * customerPayPerItem).toFixed(2)}</td>
                <td className={isLowerThanHardCost2 ? 'text-danger' : ''}>{Math.max(0, (((overwriteCost / (totalHCPerItem * (overwriteMargin - marginGap[index]))) - 1) * 100)).toFixed(2)}%</td>
              </tr>
            );
          })}
        </tbody>
      </Table>
    </div>
  );
};

export default PricingOverwriteTable;
